import APIService from '@/services/APIService.js';

export default {

  getAderencias(includeExpiredRecords) {
    return APIService.apiCall().get(`/aderenciaAis/getAderenciasAis/${includeExpiredRecords}`);
  },

  salvarAderenciaAis(postData) {
    return APIService.apiCall().post(`/aderenciaAis/salvar`, JSON.stringify(postData));
  },

  excluirAderenciaAis(id) {
    return APIService.apiCall().get(`/aderenciaAis/excluir/${id}`);
  },

  executarAderenciaAis(id) {
    return APIService.apiCall().get(`/aderenciaAis/executar/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/aderenciaAis/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  },
};
